import React from 'react';
import { Prompt } from 'react-router-dom';

class PromptPop extends React.Component {

    constructor(props) {
        super(props)
        this.beforeunload = this.beforeunload.bind(this);
    }

    componentDidMount() {
      window.addEventListener('beforeunload', this.beforeunload, false);
    }

    componentWillUnmount() {
      window.removeEventListener('beforeunload', this.beforeunload, false);
    }

    beforeunload(e) {
      if (this.props.isDataChanged) {
        e.preventDefault();
        e.returnValue = true;
      }
    }

    render() {
        return (<Prompt
            when={this.props.isDataChanged}
            message={(location, action) => {
              if (action === 'POP') {
                console.log(action);
              }
              return `Are you sure you want to leave this page without saving your data?  Click CANCEL to stay on the page and save your data. Click OK to leave the page and lose your data.`;
            }}
          />)
    }
}


export default PromptPop;


// WEBPACK FOOTER //
// ./src/components/navigationBlocker.js